import ListOfAlbums from './ListOfAlbums';
export default ListOfAlbums;